const events = ['fileProgress', 'fileSuccess', 'fileComplete', 'fileError']

export default events



// WEBPACK FOOTER //
// ./src/components/uploader/common/file-events.js